"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DraftProperties_1 = require("./DraftProperties");
var Field_1 = require("../../constants/Field");
var Draft = /** @class */ (function () {
    function Draft(type, model, name, version, content) {
        this.model = model;
        this.type = type;
        this.properties = new DraftProperties_1.Properties(name, version, content);
    }
    Draft.createDraft = function (type, model, name, version, content) {
        var draft = new Draft(type, model, name, version, content);
        return draft;
    };
    Draft.fromJson = function (json) {
        var type = json[Field_1.FIELD.TYPE];
        var model = json[Field_1.FIELD.MODEL];
        var propertiesJson = json[Field_1.FIELD.PROPERTIES];
        var name = propertiesJson[Field_1.FIELD.NAME][Field_1.FIELD.VALUE];
        var content = propertiesJson[Field_1.FIELD.CONTENT][Field_1.FIELD.VALUE];
        var version = propertiesJson[Field_1.FIELD.VERSION][Field_1.FIELD.VALUE];
        var draft = new Draft(type, model, name, version, content);
        return draft;
    };
    Draft.prototype.updateType = function (type) {
        this.type = type;
    };
    Draft.prototype.updateModel = function (model) {
        this.model = model;
    };
    Draft.prototype.updateProperties = function (properties) {
        this.properties = properties;
    };
    Draft.prototype.updateObjectId = function (objectId) {
        this.objectId = objectId;
    };
    Draft.prototype.updateVersion = function (version) {
        this.version = version;
    };
    /**
     * Converts stringified draft content to object and returns
     */
    Draft.prototype.getDraftContent = function () {
        return JSON.parse(this.properties.content.value);
    };
    /**
     * Converts data to json
     */
    Draft.prototype.toJson = function () {
        var json = Object.create(null);
        json[Field_1.FIELD.MODEL] = this.model;
        json[Field_1.FIELD.TYPE] = this.type;
        json[Field_1.FIELD.PROPERTIES] = this.properties.toJson();
        if (this.objectId && this.version) {
            json[Field_1.FIELD.OBJECTID] = this.objectId;
            json[Field_1.FIELD.VERSION] = this.version;
        }
        else {
            json[Field_1.FIELD.OBJECTID] = this.objectId;
        }
        return json;
    };
    return Draft;
}());
exports.Draft = Draft;
//# sourceMappingURL=Draft.js.map